<template>
  <el-dialog class="dialog-form" title="查看计划" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false"
    :before-close='close'>
    <el-form class="global-form2" :model="info" label-width="160px">
      <el-form-item label="计划类型:">
        <p>{{ info.planType === '1' ? '定时计划' : '智能计划' }}</p>
      </el-form-item>
      <el-form-item label="计划名称:">
        <p>{{ info.planName }}</p>
      </el-form-item>
      <el-form-item label="喷灌区域:">
        <p>{{ info.areaName }}</p>
      </el-form-item>
      <el-form-item label="计划开始时间:">
        <p>{{ info.startDate }}</p>
      </el-form-item>
      <el-form-item label="计划结束时间:">
        <p>{{ info.endDate }}</p>
      </el-form-item>
      <el-form-item v-if="info.planType === '1'" label="喷灌开启时间:">
        <p>{{ info.executeTime }}</p>
      </el-form-item>
      <el-form-item v-if="info.planType === '2'" label="喷灌启动阈值设置:">
        <p>{{ info.drought }}%</p>
      </el-form-item>

      <el-form-item label="并发数:">
        <p>{{ info.concurrentNum }}个</p>
      </el-form-item>
      <el-form-item v-if="info.planType === '1'" label="喷灌频率:">
        <p>每{{ info.intervalDays }}天开启一次喷灌</p>
      </el-form-item>
      <el-form-item label="时长:">
        <p>{{ info.keepLength }}分钟</p>
      </el-form-item>
      <el-form-item label="说明:" class="maxWidth">
        <p v-if="info.planType === '1'">{{ timeIrrigationDesc }}</p>
        <p v-if="info.planType === '2'">{{ intellectIrrigationDesc }}</p>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { timeIrrigationDesc, intellectIrrigationDesc } from '@/utils/config'

export default {
  name: 'IrrigationTimingDetail',
  props: {
    showDialog: Boolean,
    id: String
  },
  data () {
    return {
      dialogVisible: false,
      info: {
        planType: '1',
        planName: '',
        areaId: '',
        projectId: '',
        dateRange: [],
        executeTime: '',

        concurrentNum: '',
        intervalDays: '',
        keepLength: '',
        drought: ''
      }
    }
  },
  computed: {
    timeIrrigationDesc () {
      return timeIrrigationDesc
    },

    intellectIrrigationDesc () {
      return intellectIrrigationDesc
    }
  },
  watch: {
    showDialog (val) {
      this.dialogVisible = val
    },
    id (val) {
      console.log(val)
      this.getPlanDetail(val)
    }
  },
  methods: {

    getPlanDetail (id) {
      this.$axios.get(this.$apis.irrigation.selectIrrigationPlanByPlanId, {
        planId: id
      }).then((res) => {
        this.info = res
      })
    },

    close () {
      this.$emit('update:showDialog', false)
    }
  }

}
</script>

<style scoped lang="scss">
.maxWidth {
  max-width: 500px;
}
</style>
